import { StyleSheet } from 'react-native';

const style = StyleSheet.create({
  container: theme => ({
    backgroundColor: theme.colors.backgroundColorThree,
    padding: 16,
  }),
  detailsContainer: {
    flexDirection: 'row',
  },
  detailsWrapper: {
    marginTop: 10,
    flex: 1,
    paddingLeft: 20,
  },
  detailItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 15,
  },
  detailKey: {
    fontSize: 17,
  },
  detailValue: {
    fontSize: 17,
  },
  headerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  titleSubTitleContainer: {
    marginLeft: 20,
  },
  hiddenIcon: {
    opacity: 0,
  },
  title: {
    marginBottom: 10,
  },
  subTitle: {
    fontSize: 18.7,
  },
  spaceItem: width => ({
    width: width,
  }),
});
export default style;
